import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextComponent } from '../../common/block-text/block-text.component';
import {
  ReviewsInitModel,
  ReviewsInitVariables,
  ReviewsModel,
  ReviewsVariables,
} from '../../../../models/email-template/reviews.interface';
import { BaseComponent } from '../../common/BaseComponent';
import { NotificationComponent } from '../../common/notification/notification.component';
import { PinComponent } from '../../common/pin/pin.component';
import { Helper } from '../../../../utils/helper';

@Component({
    selector: 'app-reviews',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './reviews.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './reviews.component.scss'
})
export class ReviewsComponent extends BaseComponent implements OnInit {
  @Input() block: ReviewsModel = new ReviewsInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new ReviewsInitVariables()
    }
  }

  //placeholders:
  imagePlaceholder: string = 'Image';
  imageHrefPlaceholder: string = 'Enter Image Redirect Link';
  imageAltPlaceholder: string = 'Enter Image Alt Text';
  textPlaceholder: string = 'Enter Text';
  propertyNamePlaceholder: string = 'Enter Property Name';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof ReviewsVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof ReviewsVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
